/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * /* eslint react/prop-types: 1, @typescript-eslint/no-unsafe-assignment: 1, @typescript-eslint/no-unsafe-call: 1, @typescript-eslint/restrict-template-expressions: 1, @typescript-eslint/no-unsafe-return: 1, no-negated-condition: 1
 *
 * @format
 */

import React, {useState, useEffect} from 'react';
import {Box, Container} from '@chakra-ui/layout';
import TitleOverline from '../components/TitleOverline';
import Patterns from '../patterns';
import Layout from '../components/Layout';
import {getContentTypes} from '../lib/api/contentTypes';
import {getPageCategories, getContentNode} from '../lib/api/contentNodes';
import {getSeoFields} from '../lib/getSeoFields';
import {NextSeo} from 'next-seo';
import getFooter from '../lib/api/acf/footer';
import mappingFooter from '../patterns/Footer/mappingFooter';
import getMainMenu from '../lib/api/acf/mainMenu';
import mappingMainMenu from '../patterns/MainMenu/mappingMainMenu';
import PostGrid from '../patterns/PostGrid';
import {useAuth} from '../providers/authProvider';
import useUser from '../../lib/useUser';
import WYSIWYG from '../patterns/WYSIWYG';
import {wysiwygMapping} from '../patterns/WYSIWYG/wysiwygMapping';
import FadedContainer from '../components/FadedContainer';
import {ctaBannerMapping} from '../patterns/CTABanners/ctaBannerMapping';
import CTABanner from '../patterns/CTABanners';
import {colors} from '../styles/js/colors';
import Image from '../patterns/Image';
import {imageMapping} from '../patterns/Image/imageMapping';
import {titleTextBannerMapping} from '../patterns/TitleTextBanner/titleTextBannerMapping';
import TitleTextBanner from '../patterns/TitleTextBanner';
import {heroBannerMapping} from '../patterns/HeroBanners/HeroBanner/heroBannerMapping';
import HeroBanner from '../patterns/HeroBanners/HeroBanner';
import contentData from '../data/contentData';
import axios from 'axios';

const FullContent = post => {
	if (!post) {
		return;
	}

	return (
		<>
			<Box>
				{/* eslint-disable-next-line @typescript-eslint/no-unsafe-call */}
				{post.post.pageLayout.flexibleContent.map(
					(post: any, index: number) => (
						<Patterns

							fieldGroupName={post.__typename}

							post={post}
							// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
							key={`${post.fieldGroupName}_${index}`}
						/>
					),
				)}
			</Box>
			<Container maxW='container.xl' mx='auto'>
				{post.post.content ? (
					<Box mt={10} ml={0} mr='auto'>
						{

							post.post.content ? <WYSIWYG html={post.post.content} /> : null
						}
					</Box>
				) : null}
			</Container>
		</>
	);
};

const PreviewContent = data => {
	if (!data) {
		return;
	}

	const ctaProps = ctaBannerMapping(contentData.protectedContent.post);

	/* eslint @typescript-eslint/no-unsafe-call: 1, @typescript-eslint/no-unsafe-assignment: 1, array-callback-return: 1 */
	return (
		<Box pb={10} pt={10}>
			<FadedContainer>
				{data?.data?.pageLayout?.flexibleContent?.map(
					(pattern: any, index: number) => {
						switch (pattern.fieldGroupName) {
							case 'Page_Pagelayout_FlexibleContent_TitleTextBanner': {
								const patternData = titleTextBannerMapping(pattern);
								return <TitleTextBanner key={index} {...patternData} />;
							}

							case 'Page_Pagelayout_FlexibleContent_Image': {
								const patternData = imageMapping(pattern);
								return <Image key={index} {...patternData} />;
							}

							case 'Page_Pagelayout_FlexibleContent_HeroBanner': {
								const patternData = heroBannerMapping(pattern);
								return <HeroBanner {...patternData} />;
							}

							case 'Page_Pagelayout_FlexibleContent_Wysiwyg': {
								return <WYSIWYG key={index} html={pattern.wysiwyg} />;
							}

							default:
								break;
						}
					},
				)}
				{

					data.data.content ? <WYSIWYG html={data.data.content} /> : null
				}
			</FadedContainer>

			<CTABanner {...ctaProps} />
		</Box>
	);
};

// eslint-disable-next-line react/prop-types
function Page({post, seo, mainMenu, footer, categories}) {
	if (!post) {
		return null;
	}

	const {user} = useUser();

	// eslint-disable-next-line @typescript-eslint/no-unsafe-call, react/prop-types
	const filter = categories.filter(category => category.slug === 'members-content');

	const PageContent = () => {
		if (filter?.length > 0) {
			// this page is available only to registered members

			if (user.isLoggedIn && user?.stripe?.stripeSubscription !== null) {
				// user is logged in and has at least one active subscription

				return <FullContent post={post} />;
				/* eslint-disable-next-line no-else-return */
			} else {
				// not logged in, hide content

				return <PreviewContent data={post} />;
			}
			/* eslint-disable-next-line no-else-return */
		} else if (filter?.length <= 0) {
			return <FullContent post={post} />;
		}
	};

	return (
		/* eslint-disable-next-line react/prop-types */
		<Layout seo={post.seo} mainMenu={mainMenu} footer={footer}>
			<NextSeo {...seo} />
			<PageContent />
		</Layout>
	);
}

export async function getStaticPaths() {
	let contentTypes = await getContentTypes();
	// eslint-disable-next-line @typescript-eslint/no-unsafe-call
	contentTypes = contentTypes.filter(
		contentType =>
			// contentType.name !== "post" &&
			contentType.name === 'page',
	);

	// eslint-disable-next-line @typescript-eslint/no-unsafe-call
	const uris = contentTypes
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		.map(contentType => contentType.contentNodes.nodes)
		.flat()
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		.map(({uri}) => uri)
		.filter(uri => uri !== '/')
		.filter(uri => uri !== '/community/')
		.filter(uri => uri !== '/newfronttest/')
		.filter(uri => uri !== '/why-join/')
		.filter(uri => uri !== '/holiday-let-trade-suppliers/')
		.filter(uri => uri !== '/join-the-assc/');

	return {

		paths: uris,
		fallback: 'blocking',
	};
}

export async function getStaticProps({params, preview, previewData}) {
	let path = params.postType;
	if (params.postType.length > 1) {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-call
		path = params.postType.join('/');
	}

	// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
	const id = preview ? previewData.id : `/${path}`;
	const idType = preview ? 'ID' : 'URI';

	const post = await getContentNode(id, idType, preview);
	// eslint-disable-next-line no-negated-condition
	const seo = !preview ? getSeoFields(post) : null;

	const categories = await getPageCategories(id, idType);

	let mainMenu = await getMainMenu();
	mainMenu = mappingMainMenu(mainMenu);

	let footer = await getFooter();
	footer = mappingFooter(footer);

	return {
		props: {
			post,
			seo,
			mainMenu,
			footer,

			categories,
		},
		revalidate: 60,
	};
}

export default Page;
